/**
 * Auth helper for admin API requests
 * Adds Authorization header with Bearer token to all admin fetch calls
 */

export function getAuthHeaders(contentType = 'application/json') {
  const token = localStorage.getItem('admin_token');
  const headers = {};
  if (contentType) headers['Content-Type'] = contentType;
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
}

export async function authFetch(url, options = {}) {
  const token = localStorage.getItem('admin_token');
  const headers = { ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(url, { ...options, headers });

  // If 401, redirect to login
  if (res.status === 401) {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    window.location.href = '/admin/login';
    return res;
  }

  return res;
}
